























import {
  computed,
  defineComponent,
  ref,
  watch,
  vue3Model
} from '~/utils/nuxt3-migration'
import { useDep } from '~/compositions/dependency-container'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { useLoginModal } from '~/compositions/login-modal'

export default defineComponent({
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const legacyUrlService = useDep(LegacyUrlService)
    const { showModal } = useLoginModal({
      redirectAfterLogin: false,
      onSuccess: () => (isVisible.value = false)
    })

    const isVisible = ref(props.modelValue)

    watch(
      () => props.modelValue,
      newModelValue => {
        isVisible.value = newModelValue
      }
    )
    watch(isVisible, newIsVisible => emit('update:modelValue', newIsVisible))

    const registerUrl = computed(() =>
      legacyUrlService.getRegisterUrl({ gotonext: window.location.href })
    )

    return { isVisible, registerUrl, showModal }
  }
})
